import {
    studentDataUpdateSlice,
    studentDataSlice,
    logOutSlice,
    loginSlice,
    commonSlice,
    eventAddSlice,
    eventShowSlice,
    eventSingleShowSlice,
    studentDataSingleSlice,
} from 'reduxToolkit/reducers';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import { storeTypes } from 'types';

const appReducer = combineReducers<storeTypes.IStore>({
    // Common
    commonState: commonSlice.reducer, // Common Errors and etc..

    // Users
    loginState: loginSlice.reducer, // Login
    logOutState: logOutSlice.reducer, // forgotPassword

    eventAddState: eventAddSlice.reducer, //Event
    eventShowState: eventShowSlice.reducer, //Event
    eventSingleShowState: eventSingleShowSlice.reducer, //Event

    studentUpdateDataState: studentDataUpdateSlice.reducer, // Student Data Update
    studentDataState: studentDataSlice.reducer, // Student Data Update
    studentDataSingleState: studentDataSingleSlice.reducer, // Student Data  Single Update
});

// Clear set persist
const rootReducer = (state: any, action: any) => {
    if (action.type === 'logOut/logOutSuccess' || action.type === 'logOut/logOutFailed') {
        storage.removeItem('persist:root');
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }
    return appReducer(state, action);
};

export { rootReducer };
